import React, { Fragment } from "react"
import { Text, View } from "@react-pdf/renderer"
import formatNumberWithCommas from "../../../../../utils/formatNumberWithCommas"

const PdfTotals = ({ data = {}, type = "" }) => {
  // let halfAmount = data[`50_percent_amount`] || 0
  // let paid = data.paid_amount || 0
  // console.log('data', data);
  let positionTotal =
    type.toLowerCase() === "crew-bill"
      ? [...data.expenses, ...data.additional_expenses].reduce(
          (total, item) =>
            Number(item.actual_rate) * Number(item.quantity) + total,
          0
        )
      : data.expenses.reduce((total, item, i, arr) => {
          return Number(item.actual_rate) * Number(item.quantity) + total
        }, 0)

  return (
    <Fragment>
      <View>
        <Text
          style={{
            width: "100%",
            padding: 5,
          }}
        >
          TOTAL
        </Text>
        <Text
          style={{
            textAlign: "right",
            backgroundColor: "#FAF7F7",
            width: "100%",
            padding: 5,
          }}
        >
          $ {formatNumberWithCommas(positionTotal)}
        </Text>
      </View>
    </Fragment>
  )
}

export default PdfTotals
